import Information20 from '@carbon/icons-react/es/information/20';
import { Typography } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { CalendarIntegration } from 'api/timesheets/integration/calendar-integration-provider';
import { InlineNotification } from 'components/atoms/inline-notification';
import { InlineNotificationType } from 'components/atoms/inline-notification/inline-notification-types';
import {
  AlertButton,
  Message,
} from 'components/organisms/module-settings/integrations/integrations-list/styles';
import { useTranslation } from 'hooks/use-translation';
import { useTimesheetIntegrationOauthQuery } from 'queries/timesheets/calendar-integration-provider';
import {
  Drawer,
  DrawerBody,
  SelectCalenderWrapper,
  TopSelection,
} from '../component';
import { Profile } from '../profile';
import { getSourceTypeFromTimesheetConfig } from '../util';

interface Props {
  onClose: () => void;
  visible: boolean;
  configuration: Configuration;
  expiredIntegration: CalendarIntegration;
}

const StyledLink = styled(Typography.Link)`
  padding-left: var(--spacing-02);
`;

export const ReAuthCalendar: FC<Props> = ({
  onClose,
  visible,
  configuration,
  expiredIntegration,
}) => {
  const sourceType = getSourceTypeFromTimesheetConfig(configuration);
  const { data: authMeta, isLoading } =
    useTimesheetIntegrationOauthQuery(sourceType);
  const alertMessage = useTranslation('integration.alert.error.message');
  const reAuthMessage = useTranslation(
    'settings.integrations.calender.settings.alert.button.message',
  );
  const reAuthenticate = useTranslation(
    'settings.integration.alert.button.message',
  );

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      destroyOnClose
      title={<FormattedMessage id="timesheets.integration.drawer.title" />}
    >
      <DrawerBody>
        <InlineNotification
          msg={
            <Message>
              <strong>{alertMessage}</strong> {reAuthMessage}
            </Message>
          }
          type={InlineNotificationType.Error}
          button={
            <AlertButton
              size="small"
              type="tertiary"
              href={authMeta?.oauthReauthUrl}
              loading={isLoading}
            >
              {reAuthenticate}
            </AlertButton>
          }
          icon={<Information20 />}
        />
        <TopSelection>
          <SelectCalenderWrapper>
            <Typography.Text>
              <FormattedMessage id="timesheets.integrations.calender.select" />
              <StyledLink>
                {expiredIntegration.meta.oauthAuthenticatorEmail}
              </StyledLink>
            </Typography.Text>
          </SelectCalenderWrapper>
          <Profile integration={expiredIntegration} />
        </TopSelection>
      </DrawerBody>
    </Drawer>
  );
};
